import * as React from 'react'

export const CohortAnalyser = () => (
  <svg
    id='Layer_1'
    xmlns='http://www.w3.org/2000/svg'
    viewBox='-2 -5 27 27'
    xmlSpace='preserve'
    width="1em" height="1em" fill="currentColor"
  >
    <path
      d='M14.38 7.02c.36.13.49.4.48.77-.01.94 0 1.88 0 2.81.06.86-1.2.91-1.22.08-.01-.53 0-1.03 0-1.57-1.31 1.28-2.58 2.58-3.88 3.87-.38.38-.69.38-1.07-.01-.71-.74-1.47-1.41-2.15-2.18-.99 1.09-2.07 2.08-3.1 3.13-.16.16-.33.25-.56.22-.55-.05-.72-.79-.29-1.11l3.44-3.44c.34-.34.67-.34 1.01 0 .71.73 1.48 1.42 2.15 2.18 1.19-1.2 2.36-2.37 3.54-3.54-.66-.13-1.88.34-2.13-.5-.08-.32.12-.56.45-.74 1.11.03 2.22.03 3.33.03z'
      id='qnh6Tz.tif_00000103983651520159265020000001004943967583633056_'
    />
    <path
      d='M2.86 8.84c.34-5.86 7.19-9.59 12.23-6.48 4.26 2.33 5.35 8.43 2.25 12.14 1.91 1.93 3.84 3.84 5.76 5.76.63.61.31 1.23-.35 1.55h-.36c-2.25-1.83-4.15-4.1-6.27-6.09-5.05 4.16-12.82.69-13.25-5.79-.01-.36-.01-.72-.01-1.09zm8.15 7.19c3.71-.04 6.63-2.98 6.63-6.65C17.33.59 4.65.63 4.36 9.4a6.656 6.656 0 0 0 6.65 6.63z'
      id='_x33_RAeBR.tif_00000093866273481592517610000016949670987503681940_'
    />
  </svg>
)
